// ./client/components/Reports/Controls.js
import React from "react";
import { useAppContext } from "../../context/appContext";
import { Checkbox, Input, Select, RadioWithTitle } from "../../components/workspace";
import { BsFillGearFill } from "react-icons/bs";

function BusinessReports() {
	const { reports, lists, displayAlert, isLoading, handleChange, handleChanges } = useAppContext();

	const setDates = (newTerm) => {
		let endDate = new Date(reports.endDate);
		const daysAgo = new Date(endDate);
		
		let startDate = reports.startDate;

		// Term lengths in days
		if (Number(newTerm) === 1) {
			const termLength = 30;
			daysAgo.setDate(endDate.getDate() - termLength);
			startDate = daysAgo
		}
		if (Number(newTerm) === 2) {
			const termLength = 90;
			daysAgo.setDate(endDate.getDate() - termLength);
			startDate = daysAgo
		}
		// Term lengths in months
		if (Number(newTerm) === 3) {
			const monthLength = 6; 
		    daysAgo.setMonth(endDate.getMonth() - monthLength);
		    daysAgo.setDate(0); // Use start of month for longer terms
		    endDate.setDate(0);
		    startDate = daysAgo
		}
		if (Number(newTerm) === 4) {
			const monthLength = 12; 
		    daysAgo.setMonth(endDate.getMonth() - monthLength);
		    daysAgo.setDate(0); // Use start of month for longer terms
		    endDate.setDate(0);
		    startDate = daysAgo
		} 
		// Start of Month
		else if (Number(newTerm) === 5) {
			const startMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
			startDate = startMonth
			endDate = new Date()
		}
		// Start of Year
		else if (Number(newTerm) === 6) {
			const startMonth = new Date(endDate.getFullYear(), 0, 1);
			startDate = startMonth			
			endDate = new Date()
		}

		startDate = startDate.toISOString().split("T")[0];
		endDate = endDate.toISOString().split("T")[0];
		
		return { startDate, endDate };
	};

	const handleInput = (e, isNumber) => {
		let startDate = reports.startDate;
		let endDate = reports.endDate;
		const property = e.target.name;
		const value = isNumber ? parseInt(e.target.value) : e.target.value;

		let newValues = { [property]: value };
		// Change start date based on report term and set interval
		if (property === "reportTermsId") {
			startDate = setDates(value).startDate;
			endDate = setDates(value).endDate;
			const dayMilSecs = 1000 * 60 * 60 * 24;
			const beginning = new Date(startDate)
			const ending = new Date(reports.endDate)
			const diffTime = ending - beginning;
			const termLength = Math.ceil(diffTime / dayMilSecs);
			// Adjust the report interval to fit with the full report term
			let interval
			if (termLength < 35) {
				interval = 0
			} else if (termLength < 100) {
				interval = 1
			} else if (termLength < 732) {
				interval = 2
			} else
				interval = 3
			newValues = { ...newValues, startDate, endDate, interval };
		}
			// Change term length to custom if dates are altered and set interval
		if (property === "startDate" || property === "endDate") {
			newValues = { ...newValues, reportTermsId: 7 };
		}

		console.log("newValues:", newValues);
		handleChanges({
			baseObject: reports,
			baseName: "reports",
			newValues,
		});
	};

	const handleCheckBox = (e) => {
		const name = e.target.name;
		const value = e.target.checked; // grab checked instead of value
		handleChange({ baseObject: reports, name, value });
	};

	const handleRadio = (e) => {
		const name = "reports.interval";
		const baseObject = { ...reports };
		const value = e.target.value;
		console.log("value:", value);
		handleChange({ baseObject, name, value });
	};


	return (
		<div className="whole flex-parent">
			<div className="one-half flex-parent">
				<div className="whole">
					<Select
						name="reportTypesId"
						labelText="Report Type"
						handleChange={(e) => handleInput(e, true)} // designate isNumber as true
						value={reports.reportTypesId || "default"}
						options={lists && lists.listReportTypes}
					/>
				</div>
				<div className="whole">
					<BsFillGearFill />
				</div>
				{/* Select to include the three major job types */}
				<div className="one-third">
					<Checkbox
						name="reports.includeService"
						labelText="Include Service Jobs"
						checked={reports.includeService || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				{/*<div className="one-third">
					<Checkbox
						name="reports.includeNewInstall"
						labelText="Include New Install Jobs"
						checked={reports.includeNewInstall || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>*/}
				<div className="one-third">
					<Checkbox
						name="reports.includeCommercial"
						labelText="Include Commercial Jobs"
						checked={reports.includeCommercial || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				{/* Select to include quantity and value */}
				<div className="one-half">
					<Checkbox
						name="reports.showQuantity"
						labelText="Include Quantity"
						checked={reports.showQuantity || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				<div className="one-half">
					<Checkbox
						name="reports.showValue"
						labelText="Include Value"
						checked={reports.showValue || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				{/* Select to include grid lines */}
				<div className="one-third">
					<Checkbox
						name="reports.showXGrid"
						labelText="Show X-Axis Grid Lines"
						checked={reports.showXGrid || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				<div className="one-third">
					<Checkbox
						name="reports.showYGrid"
						labelText="Y-Axis Grid Lines"
						checked={reports.showYGrid || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
				<div className="one-third">
					<Checkbox
						name="reports.showY1Grid"
						labelText="2nd Y-Axis Grid Lines"
						checked={reports.showY1Grid || false}
						handleChange={(e) => handleCheckBox(e)}
					/>
				</div>
			</div>
			{/* Report term length and dates*/}
			<div className="one-half flex-parent">
				<div className="whole">
					<Select
						name="reportTermsId"
						labelText="Term Length"
						handleChange={(e) => handleInput(e, true)} // designate isNumber as true
						value={reports.reportTermsId || "default"}
						options={lists && lists.listReportTerms}
					/>
				</div>
				<div className="one-half">
					<Input
						type="date"
						name="startDate"
						labelText="Report Start Date"
						value={reports.startDate || ""}
						handleChange={(e) => handleInput(e)}
					/>
				</div>
				<div className="one-half">
					<Input
						type="date"
						name="endDate"
						labelText="Report End Date"
						value={reports.endDate || ""}
						handleChange={(e) => handleInput(e)}
					/>
				</div>
				{/* Interval length selection */}
				<div className="whole checkbox">
					<RadioWithTitle
						title="Interval Length"
						optionNames={["daily", "weekly", "monthly"]} //, "quarterly"
						labels={["daily", "weekly", "monthly"]} //, "quarterly"
						value={reports.interval}
						handleChange={handleRadio}
					/>
				</div>
			</div>
		</div>
	);
}

export default BusinessReports;
